import { Controller } from '@hotwired/stimulus';
import { Modal } from 'bootstrap';

// アクセス許可の承認待ちがあるとき、permissions ページで承認確認モーダルを
// 自動で開く (#2291)。Pro(税理士等)の招待からサインアップした直後の利用者に
// 「誰が・何のために・許可すると何ができるのか」を説明する。
export default class extends Controller {
  connect() {
    Modal.getOrCreateInstance(this.element).show();
  }
}
